import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showAppAlert } from "../../../store/reducers/appreducer";
import PhoneInput from "react-phone-input-2";
import "react-phone-number-input/style.css";
import moment from "moment-timezone";
import {
  Button,
  MenuItem,
  TextField,
  Box,
  Paper,
  Typography,
  Grid,
  CircularProgress,
} from "@mui/material";
import { baseURL } from "../../../config";

const SlotSelection = () => {
  const dispatch = useDispatch();
  const { jobId, resume_id } = useParams();
  const [timeSlots, setTimeSlots] = useState([]);
  const [availableDates, setAvailableDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [availableSlots, setAvailableSlots] = useState([]);
  const [selectedSlotId, setSelectedSlotId] = useState("");
  const [isInterviewScheduled, setIsInterviewScheduled] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [timeZone, setTimeZone] = useState("GMT");
  const [interviewType, setInterviewType] = useState("");
  const [CallMode, setCallMode] = useState(""); // phoneCall modes
  const [loading, setLoading] = useState(false);
  const [loadDateSlot, setloadDateSlot] = useState(false);
  const [availableTimes, setAvailableTimes] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  // Fetch and adjust slots by timezone
  // useEffect(() => {
  const fetchTimeSlots = async () => {
    setloadDateSlot(true);
    try {
      const response = await axios.get(`${baseURL}create_time_slots/${jobId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const slots = response.data.filter((slot) => slot.status !== "booked");

      const timeZoneMapping = {
        IST: "Asia/Kolkata",
        GMT: "GMT",
        UTC: "UTC",
        ET: "America/New_York",
        CET: "Europe/Berlin",
        CST: "Asia/Shanghai",
        JST: "Asia/Tokyo",
        PT: "America/Los_Angeles",
        AEST: "Australia/Sydney",
        BRT: "America/Sao_Paulo",
        MSK: "Europe/Moscow",
        AST: "Asia/Riyadh",
        PST: "America/Vancouver",
      };

      // Get the corresponding IANA time zone
      const ianaTimeZone = timeZoneMapping[timeZone];

      // // Adjust dates and times based on timezone
      // const adjustedSlots = slots.map((slot) => {
      //   const start = moment(slot.start_time).tz(
      //     timeZone === "IST" ? "Asia/Kolkata" : "GMT"
      //   );
      //   const end = moment(slot.end_time).tz(
      //     timeZone === "IST" ? "Asia/Kolkata" : "GMT"
      //   );

      //   // Format the adjusted date and time
      //   const formattedStartDate = start.format("YYYY-MM-DD");
      //   const formattedStartTime = start.format("HH:mm");
      //   const formattedEndDate = end.format("YYYY-MM-DD");
      //   const formattedEndTime = end.format("HH:mm");

      //   return {
      //     ...slot,
      //     start_time: formattedStartDate + " " + formattedStartTime,
      //     end_time: formattedEndDate + " " + formattedEndTime,
      //     date: formattedStartDate,
      //   };
      // });
      // Adjust dates and times based on timezone
      const adjustedSlots = slots.map((slot) => {
        // Adjust start and end times based on selected timezone
        const start = moment(slot.start_time).tz(ianaTimeZone);
        const end = moment(slot.end_time).tz(ianaTimeZone);

        const formattedStartDate = start.format("YYYY-MM-DD");
        const formattedStartTime = start.format("HH:mm");
        const formattedEndDate = end.format("YYYY-MM-DD");
        const formattedEndTime = end.format("HH:mm");

        return {
          ...slot,
          start_time: formattedStartDate + " " + formattedStartTime,
          end_time: formattedEndDate + " " + formattedEndTime,
          date: formattedStartDate,
        };
      });

      const uniqueDates = [
        ...new Set(adjustedSlots.flatMap((slot) => [slot.date])),
      ].sort((a, b) => new Date(a) - new Date(b));

      setAvailableDates(uniqueDates);
      setAvailableSlots(adjustedSlots);
      setErrorMessage("");
    } catch (error) {
      console.error("Error fetching time slots:", error);
      setErrorMessage("No Dates and Slots Found");
    } finally {
      setloadDateSlot(false);
    }
  };
  //   fetchTimeSlots();
  // }, [jobId, timeZone]);

  useEffect(() => {
    if (jobId && timeZone) {
      fetchTimeSlots();
    } else {
      setErrorMessage("Invalid jobId or timeZone. Please check the URL.");
      setloadDateSlot(false);
    }
  }, [jobId, timeZone]);

  useEffect(() => {
    if (selectedDate) {
      const timesForDate = availableSlots
        .filter((slot) => slot.date === selectedDate)
        .map((slot) => ({
          id: slot.id,
          start: slot.start_time.split(" ")[1],
          end: slot.end_time.split(" ")[1],
        }));

      setAvailableTimes(timesForDate);
    }
  }, [selectedDate, availableSlots]);

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    const options = {
      hour: "2-digit",
      minute: "2-digit",
      timeZone: timeZone === "IST" ? "Asia/Kolkata" : "GMT",
    };
    return date.toLocaleTimeString([], options);
  };

  const handleSlotSelection = (slotId) => {
    setSelectedSlotId(slotId);
  };

  // handle the phone number change
  const handlePhoneChange = (value, country, isValid) => {
    const countryCodeLength = country?.dialCode?.length || 0; // Length of the country code
    const phoneWithoutCountryCode = value.slice(countryCodeLength); // Exclude country code
  
    if (phoneWithoutCountryCode.length >= 10) {
      setIsPhoneValid(true); // Valid if 10 or more digits
    } else {
      setIsPhoneValid(false); // Invalid if less than 10 digits
    }
    // console.log(value);
    setPhoneNumber(value);
  };

  // Schedule interview
  const handleInterview = async (type, mode) => {
    setLoading(true);
    setCallMode(mode);
    try {
      let payload = {};

      if (type === "Phone") {
        payload =
          mode === "S"
            ? {
                slot_id: selectedSlotId,
                phone: phoneNumber,
                mode: "S",
                interview_mode: "P",
              }
            : {
                slot_id: selectedSlotId,
                phone: phoneNumber,
                mode: "I",
                interview_mode: "P",
              };
      } else if (type === "Zoom") {
        payload =
          mode === "V"
            ? {
                slot_id: selectedSlotId,
                phone: phoneNumber,
                interview_mode: "V",
              }
            : {
                slot_id: selectedSlotId,
                phone: phoneNumber,
                interview_mode: "V",
                zoom_interview_mode: "I",
              };
      } else if (type === "Chat") {
        payload = {
          slot_id: selectedSlotId,
          phone: phoneNumber,
          interview_mode: "C",
        };
      }
      await axios.post(`${baseURL}schedule/${jobId}/${resume_id}`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });

      console.log(payload);
      dispatch(
        showAppAlert({
          show: true,
          alertType: "success",
          alertMessage: "Interview scheduled successfully!",
        })
      );
      setIsInterviewScheduled(true);
    } catch (error) {
      console.error("Error scheduling interview:", error);

      dispatch(
        showAppAlert({
          show: true,
          alertType: "error",
          alertMessage: "Failed to schedule interview.",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f0f2f5",
      }}
    >
      <Paper
        sx={{
          width: "600px",
          padding: "40px",
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
        }}
      >
        {loadDateSlot ? ( // Step 2: Display loading while fetching
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <CircularProgress color="primary" />
            <Typography
              variant="subtitle1"
              sx={{
                fontFamily: "Montserrat",
                fontWeight: 500,
                marginTop: 2,
                color: "#202224",
              }}
            >
              Loading...
            </Typography>
          </div>
        ) : errorMessage ||
          availableDates.length === 0 ||
          availableSlots.length === 0 ? (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Typography
              variant="h6"
              sx={{
                fontFamily: "Montserrat",
                fontWeight: 700,
                color: "#d32f2f",
              }}
            >
              {errorMessage || "No Dates and Slots Found"}
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                fontFamily: "Montserrat",
                fontWeight: 400,
                color: "#757575",
                marginTop: "10px",
              }}
            >
              Please check the URL or try refreshing the page.
            </Typography>
          </div>
        ) : isInterviewScheduled ? (
          <Typography
            variant="h5"
            sx={{
              fontFamily: "Montserrat",
              fontWeight: 700,
              color: "#202224",
              opacity: 0.9,
              marginBottom: 2,
            }}
          >
            🎉 Congratulations!
            <br />
            Interview Scheduled. You may leave this page.
          </Typography>
        ) : (
          <>
            <Typography
              variant="h5"
              gutterBottom
              sx={{
                fontFamily: "Montserrat",
                fontWeight: 700,
                textAlign: "center",
                color: "#202224",
                opacity: 0.85,
                mb: 3,
              }}
            >
              Select a Time Slot
            </Typography>

            <Grid container spacing={2} justifyContent="center">
              {/* Dropdown for selecting timezone */}
              <Grid item xs={12}>
                <TextField
                  select
                  label="Select Time Zone"
                  value={timeZone}
                  onChange={(e) => setTimeZone(e.target.value)}
                  sx={{ width: "100%" }}
                >
                  <MenuItem value="IST">IST (Indian Standard Time)</MenuItem>
                  <MenuItem value="GMT">GMT (Greenwich Mean Time)</MenuItem>
                  <MenuItem value="UTC">
                    UTC (Coordinated Universal Time)
                  </MenuItem>
                  <MenuItem value="ET">ET (Eastern Time)</MenuItem>
                  <MenuItem value="CET">CET (Central European Time)</MenuItem>
                  <MenuItem value="CST">CST (China Standard Time)</MenuItem>
                  <MenuItem value="JST">JST (Japan Standard Time)</MenuItem>
                  <MenuItem value="PT">PT (Pacific Time)</MenuItem>
                  <MenuItem value="AEST">
                    AEST (Australian Eastern Standard Time)
                  </MenuItem>
                  <MenuItem value="BRT">BRT (Brasília Time)</MenuItem>
                  <MenuItem value="MSK">MSK (Moscow Standard Time)</MenuItem>
                  <MenuItem value="AST">AST (Arabian Standard Time)</MenuItem>
                  <MenuItem value="PST">PST (Pacific Standard Time)</MenuItem>
                </TextField>
              </Grid>

              {/* Date Selection */}
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="Select Date"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  sx={{ width: "100%" }}
                >
                  {availableDates.map((date) => (
                    <MenuItem key={date} value={date}>
                      {date}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* Time Slot Selection */}
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="Select Time Slot"
                  value={selectedSlotId}
                  onChange={(e) => setSelectedSlotId(e.target.value)}
                  sx={{ width: "100%" }}
                  disabled={!selectedDate}
                >
                  {availableTimes.map((time) => (
                    <MenuItem key={time.id} value={time.id}>
                      {time.start} - {time.end} {timeZone}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              {/* Conditional TimeZone and Slot selection */}
              {/* Interview Type Dropdown */}
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="Interview Type"
                  value={interviewType}
                  onChange={(e) => setInterviewType(e.target.value)}
                  sx={{ width: "100%" }}
                >
                  <MenuItem value="Chat">Chat Interface</MenuItem>
                  <MenuItem value="Zoom">Zoom Call</MenuItem>
                  <MenuItem value="Phone">Phone Call</MenuItem>
                </TextField>
              </Grid>
              {/* phone number */}
              <Grid
                item
                xs={12}
                sm={6}
                display="flex"
                flexDirection="column"
                alignItems="center"
              >
                <PhoneInput
                  country={"us"} // Default country
                  value={phoneNumber}
                  onChange={(value, countryData, isValid) =>
                    handlePhoneChange(value, countryData, isValid)
                  }
                  inputStyle={{
                    width: "100%",
                    // marginBottom: "1.5rem",  
                    height: "54px",
                  }}
                  containerStyle={{ marginBottom: "1.5rem" }}
                  placeholder="Enter phone number"
                  international
                />
              </Grid>
              {/* Error message*/}
              {!isPhoneValid && phoneNumber && (
                <Grid item xs={12}>
                  <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                    Phone number is invalid or incomplete.
                  </Typography>
                </Grid>
              )}
            </Grid>
            {/* Conditional rendering for Phone Call options */}
            {interviewType == "Phone" && (
              <Grid container spacing={2} mt={2}>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleInterview(interviewType, "S")}
                    sx={{ width: "100%" }}
                    disabled={
                      !selectedSlotId ||
                      !phoneNumber ||
                      !isPhoneValid ||
                      !interviewType ||
                      loading
                    }
                  >
                    {loading && CallMode === "S" ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Scheduled Call"
                    )}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => handleInterview(interviewType, "I")}
                    sx={{ width: "100%" }}
                    disabled={
                      !selectedSlotId ||
                      !phoneNumber ||
                      !isPhoneValid ||
                      !interviewType
                    }
                  >
                    {loading && CallMode === "I" ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Instant Call"
                    )}
                  </Button>
                </Grid>
              </Grid>
            )}
            {interviewType == "Zoom" && (
              <Grid container spacing={2} mt={2}>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleInterview(interviewType, "V")}
                    sx={{ width: "100%" }}
                    disabled={
                      !selectedSlotId ||
                      !phoneNumber ||
                      !isPhoneValid ||
                      !interviewType ||
                      loading
                    }
                  >
                    {loading && CallMode !== "I" ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Scheduled Call"
                    )}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => handleInterview(interviewType, "I")}
                    sx={{ width: "100%" }}
                    disabled={
                      !selectedSlotId ||
                      !phoneNumber ||
                      !isPhoneValid ||
                      !interviewType
                    }
                  >
                    {loading && CallMode === "I" ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Instant Call"
                    )}
                  </Button>
                </Grid>
              </Grid>
            )}
            {/* Schedule Interview Button */}
            {interviewType === "Chat" && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleInterview(interviewType, "C")}
                disabled={
                  !selectedSlotId ||
                  !phoneNumber ||
                  !isPhoneValid ||
                  !interviewType ||
                  loading
                }
                sx={{
                  marginTop: 3,
                  backgroundColor: "#0077cc",
                  "&:hover": { backgroundColor: "#005fa3" },
                  padding: "10px 20px",
                  fontSize: "16px",
                }}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Schedule Interview"
                )}
              </Button>
            )}
          </>
        )}
      </Paper>
    </Box>
  );
};

export default SlotSelection;
